/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Ai_ActionsInputs */

const en_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI actions`)
};

const de_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Aktionen`)
};

const fr_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions IA`)
};

const es_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones IA`)
};

const it_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni AI`)
};

const nl_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-acties`)
};

const pl_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akcje AI`)
};

const fi_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-toiminnot`)
};

const da_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-handlinger`)
};

const sv_pricing_compare_ai_actions = /** @type {(inputs: Pricing_Compare_Ai_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-aktioner`)
};

/**
* | output |
* | --- |
* | "AI actions" |
*
* @param {Pricing_Compare_Ai_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_ai_actions = /** @type {((inputs?: Pricing_Compare_Ai_ActionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Ai_ActionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_ai_actions(inputs)
	if (locale === "fr") return fr_pricing_compare_ai_actions(inputs)
	if (locale === "es") return es_pricing_compare_ai_actions(inputs)
	if (locale === "it") return it_pricing_compare_ai_actions(inputs)
	if (locale === "nl") return nl_pricing_compare_ai_actions(inputs)
	if (locale === "pl") return pl_pricing_compare_ai_actions(inputs)
	if (locale === "fi") return fi_pricing_compare_ai_actions(inputs)
	if (locale === "da") return da_pricing_compare_ai_actions(inputs)
	if (locale === "sv") return sv_pricing_compare_ai_actions(inputs)
	return en_pricing_compare_ai_actions(inputs)
});